











import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from './store/modules/user/user.store';

import SpaServer from '@/core/spa/SpaServer.vue';
import Login from './components/Login.vue';

@Component({
    components: {
        SpaServer,
        Login
    }
})
export default class App extends Vue {
    get isLoggedIn() {
        return UserModule.IsLoggedIn;
    }
}
